import { Layout, Page } from "@fdoh/health-ui-react";
import { useHistory, useLocation } from "react-router-dom";
import UserForm from "../UserForm";
import ApplicationDetailsPage from "../Home/ApplicationDetails";


// TODO: Add error handling

const CreateUserPage = () => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
    
    debugger;
  return   (
      <Page.Container>
      <Page.Body>
        <Layout.Container>
                  <UserForm
                      id="UserForm"
                      title="User Form"
                      action="post"
          
                      returnPath={`/userManagement`}
          />
        </Layout.Container>
      </Page.Body>
    </Page.Container>
  ) 
    
};

export default CreateUserPage;